
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type GetTweets200PageAllOfThreeContentItemMediaLinksItemLinkType = typeof GetTweets200PageAllOfThreeContentItemMediaLinksItemLinkType[keyof typeof GetTweets200PageAllOfThreeContentItemMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweets200PageAllOfThreeContentItemMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
